import { JSX, useEffect } from 'react';

type Props = {
  children: JSX.Element;
  isActive: boolean;
  onActive: () => void;
};

/**
 * Built specifically for NavLink children use case.
 * Allows isActive update in a side-effect to avoid interfering with React's render.
 */
export default function WithActiveSync({ children, isActive, onActive }: Props) {
  useEffect(() => {
    if (isActive) onActive();
  }, [isActive, onActive]);
  return children;
}
